export default "__VITE_ASSET__a51d9ee6__"